module.exports = __webpack_public_path__ + "static/media/Vittoria Garisto.ccf2dd39.png";